var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"dsn-color-pannel",style:(("background:" + _vm.color)),attrs:{"title":("" + _vm.color)}})}
var staticRenderFns = []

export { render, staticRenderFns }